import { useEffect, useState } from 'react';
import ImageUploader from '../ImageUploader';

export const bannerSizes = [
    { size: 'xs-md', width: 576 },
    { size: 'md-lg', width: 992 },
    { size: 'xl', width: 1200 }
];

const BannerUploader = ({
    image = '',
    categorySlug = '',
    bucket = 'shop_category_banners',
    sizes = bannerSizes,
    onChange
}) => {
    const [images, setImages] = useState(image.split(';'));
    const handleImageUpdate = (url, index) => {
        let newImages = [...images];
        newImages[index] = url;
        const newImageString = newImages.join(';');
        onChange(newImageString);
    };
    useEffect(() => {
        if (image) {
            setImages(image.split(';'));
        }
    }, [image]);
    return (
        <div className="banner-uploader">
            {sizes.map(({ size, width, label }, index) => {
                let path = size ? `${categorySlug}_${size}` : categorySlug;
                return (
                    <ImageUploader
                        key={path}
                        label={label || `Upload ${size} Banner`}
                        image={images[index]}
                        bucket={bucket}
                        id={path}
                        minWidth={width}
                        onUpload={(url) => handleImageUpdate(url, index)}
                        showWarning={false}
                        unique
                    />
                );
            })}
        </div>
    );
};

export default BannerUploader;
